import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import className from 'classnames';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
  addNotification,
} from '../lib/helpers';

import Modal from './Modal';
import Notification from '../components/Notification';

const ChangeBioModal = ({
  isActive,
  onToggleModal,
  checkIds,
}) => {
  const [isActiveDropdown, isActiveDropdownSet] = useState(false)
  const [isActiveSave, isActiveSaveSet] = useState(false)
  const [newTemplateName, newTemplateNameSet] = useState('')
  const [selectedTemplate, selectedTemplateSet] = useState({})
  const [textareaValue, textareaValueSet] = useState('')
  const [noteValue, noteValueSet] = useState('')
  const [templates, templatesSet] = useState([])
  const [isLoading, isLoadingSet] = useState(false)

  useEffect(() => {
    axios.get(`/api/bio_templates`)
      .then((res) => {
        templatesSet(get(res, 'data.bioTemplates'))
      })
  }, [])

  return (
    <Modal
      isActive={isActive}
      onToggleModal={onToggleModal}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          isLoadingSet(true)

          axios.put(`/${gon.currentProvider}/api/bulk/users`, {
            ids: checkIds,
            biography: textareaValue,
            note: noteValue,
            authenticity_token: CSRF_TOKEN,
          })
            .then((res) => {
              if (res.status == 200 && get(res, 'data.message')) {
                addNotification({
                  message: get(res, 'data.message'),
                  type: Notification.NOTIFICATION_TYPES.success,
                })
              }
            })
            .catch((error) => {
              addNotification({
                message: get(error, 'response.data.message'),
                type: Notification.NOTIFICATION_TYPES.error,
              })
            })
            .then(() => {
              // We need to delay this because it's on a worker.
              // So it will not update immediately.
              window.setTimeout(() => {
                window.location.reload()
              }, 3000)
            })
        }}
      >
        <h3 className='Modal__h3'>Change biography</h3>

        <div className='ChangeBioModal'>
          <div className='ChangeBioModal__select'>
            <a
              className='Select'
              onClick={() => {
                isActiveDropdownSet(!isActiveDropdown)
              }}
            >
              {get(selectedTemplate, 'text') ?
                <div className='ChangeBioModal__select__panel__dl__item'>
                  <dt>{get(selectedTemplate, 'name')}</dt>
                  <dd>{get(selectedTemplate, 'text')}</dd>
                </div>
              :
                <span className='ChangeBioModal__select__span'>Select template</span>
              }
            </a>

            <div
              className={className('ChangeBioModal__select__panel', {
                'ChangeBioModal__select__panel--active': isActiveDropdown,
              })}
            >
              <h3 className='ChangeBioModal__select__panel__h3'>Select template</h3>

              {templates.length == 0 &&
                <p className='ChangeBioModal__select__panel__p'>No template yet.</p>
              }

              <dl className='ChangeBioModal__select__panel__dl'>
                {templates.map((x, i) => (
                  <a
                    key={i}
                    className='ChangeBioModal__select__panel__dl__item'
                    onClick={() => {
                      selectedTemplateSet(x)
                      textareaValueSet(get(x, 'text'))
                      isActiveSaveSet(false)
                      isActiveDropdownSet(false)
                    }}
                  >
                    <dt>{x.name}</dt>
                    <dd>{x.text}</dd>

                    <span
                      className='ChangeBioModal__select__panel__dl__item__span'
                      onClick={(e) => {
                        e.stopPropagation()

                        if (confirm('Are you sure you want to delete?')) {
                          axios.delete(`/api/bio_templates/${x.id}`, {
                            data: {
                              authenticity_token: CSRF_TOKEN,
                            },
                          })
                            .then((res) => {
                              if (get(res, 'data.messages') == 'success') {
                                templatesSet(templates.filter((y) => y.id != x.id))
                                selectedTemplateSet({})
                              }
                            })
                        }
                      }}
                    />
                  </a>
                ))}
              </dl>
            </div>
          </div>

          <textarea
            className='Input'
            rows={5}
            value={textareaValue}
            onChange={(e) => {
              if (get(selectedTemplate, 'text')) {
                selectedTemplateSet({})
              }

              if (e.target.value.length == 0) {
                isActiveSaveSet(false)
              }

              textareaValueSet(e.target.value)
            }}
          />

          <textarea
            className='Input'
            placeholder='Note'
            rows={5}
            value={noteValue}
            onChange={(e) => {
              noteValueSet(e.target.value)
            }}
          />

          <div
            className='ChangeBioModal__save'
            disabled={get(selectedTemplate, 'text') || textareaValue.length == 0}
          >
            <label className='ChangeBioModal__save__label'>
              <input
                type='checkbox'
                checked={isActiveSave}
                onChange={(e) => {
                  isActiveSaveSet(e.target.checked)
                }}
              />

              <span className='CheckBox' />
              <span className='ChangeBioModal__save__label__span'>Save as new template</span>
            </label>

            <div
              className={className('ChangeBioModal__save__inputs', {
                'ChangeBioModal__save__inputs--active': isActiveSave,
              })}
            >
              <input
                type='text'
                className='Input'
                placeholder='Template name'
                value={newTemplateName}
                onChange={(e) => {
                  newTemplateNameSet(e.target.value)
                }}
              />

              <a
                className='Button'
                disabled={newTemplateName.length == 0}
                onClick={() => {
                  axios.post(`/api/bio_templates`, {
                    bio_template: {
                      name: newTemplateName,
                      text: textareaValue,
                    },
                    authenticity_token: CSRF_TOKEN,
                  })
                    .then((res) => {
                      if (get(res, 'data.bioTemplate.id')) {
                        templatesSet([
                          ...templates,
                          get(res, 'data.bioTemplate'),
                        ])

                        isActiveSaveSet(false)
                        newTemplateNameSet('')
                        selectedTemplateSet(get(res, 'data.bioTemplate'))
                      }
                    })
                }}
              >
                Save
              </a>
            </div>
          </div>

          <div className='Modal__footer'>
            <a
              className='Button Button--gray-light'
              onClick={onToggleModal}
              disabled={isActiveSave}
            >
              Cancel
            </a>

            <button
              className='Button Button--blue'
              disabled={isActiveSave || isLoading}
            >
              {isLoading ? 'Loading …' : 'Update'}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
}

ChangeBioModal.propTypes = {
};

export default ChangeBioModal;
